export default "__VITE_ASSET__DzbGl87Z__"